import { model as i18n } from '!/i18n'
import { model as paymentInfoModel } from '$/payment-info'
import { createEvent, sample } from 'effector'
import type { PartnerProductDetailsFormatted } from '~/entities/partner-product'
import { anyPaymentInitiated } from './model'

export const selectPartnerProductPaymentButton =
  createEvent<PartnerProductDetailsFormatted>()

export const payForPartnerProduct =
  createEvent<PartnerProductDetailsFormatted>()

sample({
  clock: payForPartnerProduct,
  target: anyPaymentInitiated,
})

sample({
  clock: selectPartnerProductPaymentButton,
  target: payForPartnerProduct,
})

sample({
  clock: payForPartnerProduct,
  source: i18n.$t,
  fn: ({ t }, partnerProduct) => ({
    name: partnerProduct.name,
    title: t('partner_products'),
    imageUrl: partnerProduct.coverImageUrl,
    labels: null,
    priceSettings: null,
    isCustomFallbackImage: true,
  }),
  target: paymentInfoModel.$uiPaymentInfo,
})
